import { MarketplaceReviewSelectionDetails } from '@/contracts/marketplace/review-records';

type GenerateAiAnswerPayload = {
    reviewFeedItemId: string;
};

export const buildMassAnswerAiPayload = (review: MarketplaceReviewSelectionDetails): GenerateAiAnswerPayload => ({
    reviewFeedItemId: review.id,
});
